/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

/**
 * Generates a CSV export file and triggers an automatic download. Two different implementations exist:
 *
 * Bits taken from two articles
 *   Angular solution - https://gist.github.com/derekshi/2d4969c59627ab5aca65b37eaeab72fc
 *   Better formatting of output - https://www.reddit.com/r/angularjs/comments/4f2rg7/angular_2_how_to_export_a_html_table_to_a_csv_file/
 *
 * First implementation - export an array of objects as csv
 * ----------------------------------------------------------------------------------------------------------------
 * <csv-export [data]="exportData" [headers]="exportHeaders" [fileName]="'siftrock-contacts.csv'"></csv-export>
 *
 * In component:
 *   this.exportHeaders = [...]
 *   this.exportData = [...]
 *
 * It's important to add headers first, as the change to data is what triggers the creation of the csv file
 *
 * Second impementation - CSV was rendered server-side and just needs download
 * -----------------------------------------------------------------------------------------------------------------
 * <csv-export [csv]="exportData" [fileName]="'siftrock-emails.csv'"></csv-export>
 *
 * In this case CSV should be a string and fully formatted for export. Component:
 *   this.exportData = '...'
 */
import { Component, OnChanges, Input, Output, EventEmitter, Renderer } from '@angular/core';

@Component({
  selector: 'csv-export',
  template: ``
})
export class CsvExportComponent implements OnChanges {

  @Input() headers: string[] = [];
  @Input() data: any[] = [];
  @Input() csv: string = '';
  @Input() fileName: string = 'data.csv';
  @Output() onError = new EventEmitter<Error>();

  constructor(private renderer: Renderer) {
  }

  ngOnChanges(changes:any): void {
    if (changes.data && changes.data.currentValue) {
      this.build();
    }
    else if (changes.csv && changes.csv.currentValue) {
      this.buildDownloader(this.csv);
    }
  }

  build() {
    if (!this.data.length) {
      this.onError.emit(new Error('Data not available.'));
      return;
    }

    let csvString = this.construct();
    this.buildDownloader(csvString);
  }

  private getDocumentBody(): any {
    return document.body;
  }

  private construct(): string {
    var rows = 0;
    let tabText = '';
    const keys = Object.keys(this.data[0]);
    if (!this.headers.length) {
      // if no headers are passed, use data keys for headers
      this.headers = keys;
    }

    this.headers.forEach(h => {
      tabText += '"' + h + '",';
    });

    if (tabText.length > 0) {
      tabText = tabText.slice(0, -1);
      tabText += '\r\n';
    }

    this.data.forEach(d => {
      keys.forEach(k => {
        if (d.hasOwnProperty(k) && d[k] != null) {
          tabText += '"' + d[k] + '",';
        } else {
          tabText += '"",';
        }
      });

      tabText = tabText.slice(0, -1);
      tabText += '\r\n';
    });

    return tabText;
  }

  private buildDownloader(data) {
    var blob = new Blob([data], { "type": 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, this.fileName);
    }
    else {
      let anchor = this.renderer.createElement(this.getDocumentBody(), 'a');
      // check for download support in browser
      if (anchor.download !== undefined) {
        this.renderer.setElementStyle(anchor, 'visibility', 'hidden');
        var url = URL.createObjectURL(blob);
        this.renderer.setElementAttribute(anchor, 'href', url);
        this.renderer.setElementAttribute(anchor, 'target', '_blank');
        this.renderer.setElementAttribute(anchor, 'download', this.fileName);

        setTimeout(() => {
          this.renderer.invokeElementMethod(anchor, 'click');
          this.renderer.invokeElementMethod(anchor, 'remove');
        }, 5);
      }
      else {
        this.onError.emit(new Error('Browser does not support download.'));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/csv-export/csv-export.component.ts